import { createListResponseSchema } from './ListResponse.js';
import { PageSchema } from './common.js';
export function createPaginatedListResponseSchema(itemSchema) {
    return createListResponseSchema(itemSchema)
        .extend({
        page: PageSchema,
    })
        .strict();
}
//# sourceMappingURL=PaginatedListResponse.js.map